import styled from 'styled-components';
import theme from '../../../../theme';

const Container = styled.div`
    text-align: center;
    font-weight: 400;
    margin: 10px 0;

    ul {
        list-style-type: none;
        margin-top: 10px;
        text-align: start;

        li {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border: 2px solid ${theme.primaryColor};
            border-radius: 8px;
            padding: 10px;

            div {
                display: flex;
                flex-direction: column;
                font-size: 13px;
                font-weight: 400;
                color: ${theme.primaryColor};

                strong {
                    font-size: 16px;
                    font-weight: 700;
                }
            }

            svg {
                cursor: pointer;
                padding: 6px 0 6px 30px;
            }
        }

        li + li {
            margin-top: 5px;
        }
    }
`;

export { Container };